export const systemLogsConstants = {
    EVENTS_LOGS_DATA: "eventsLogsData"
}